import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsText = (props: Props) => {
  const { children, palette = 'black' } = props;

  const textStyles = palette === 'white' ? styles.textWhite : styles.textBlack;

  return (
    <BodyText sizeMatch={['18']} style={textStyles}>
      {children}
    </BodyText>
  );
};

export const ProductDetailsTextSeparator = () => (
  <BodyText sizeMatch={['18']} bold>
    {'    '}•{'    '}
  </BodyText>
);

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  textWhite: {
    color: theme.colors.WHITE,
  },
  textBlack: {
    color: theme.colors.BLACK,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  palette?: Palette;
}>;

type Palette = 'black' | 'white';
